/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventUserRpc
 */
import * as References from './LearningEventUserRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventUserRpc#getEvents
 */
export const GET_EVENTS_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_LearningEventUserRpc_getEvents';
export const GET_EVENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_EVENTS_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength', 'internalName', 'eventSessionGroup', 'language', 'visibility', 'groupId', 'ids', 'sortOrder'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getEventsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventUserRpc#getEventById
 */
export const GET_EVENT_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_LearningEventUserRpc_getEventById';
export const GET_EVENT_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_EVENT_BY_ID_QUERY_FIELD_NAME,
  args: ['eventId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getEventByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});